<template>
    <v-dialog
        v-model="dialog"
        fullscreen
    >
        <v-card>
            <v-toolbar
                dark
                color="primary"
            >
                <v-toolbar-title>Preview Message</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                        dark
                        text
                        @click="closeDialog"
                    >
                        Ok
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text>

                <v-img
                    style="margin-top: 15px;"
                    v-for="(meta_data, index) in blobs_meta_data"
                    :key="index"
                    :src="$rc.blobURL(meta_data.object_name)"
                    max-height="400"
                    max-width="400"
                />

                <v-textarea
                    label="Message"
                    autofocus
                    auto-grow
                    disabled
                    rows="1"
                    v-model="message"
                    :hint="hint"
                    persistent-hint
                    style="margin-top: 15px"
                />

                <div
                    v-if="technical_details != null"
                >
                    Technical Details<br/>
                    <m-code-block
                        :click_anywhere_to_copy="false"
                        v-html="$rc.htmlLinebreak(technical_details)"
                    >
                    </m-code-block>
                </div>

            </v-card-text>

        </v-card>
    </v-dialog>
</template>

<script>

export default {

    props: {

        hint: {
            type: String,
            default: () => {
                return null;
            }
        },

    },

    data() {
        return {
            dialog: false,
            is_valid: true,
            message: '',
            blobs_meta_data: [],
            technical_details: null,
        }
    },

    methods: {

        showDialog(message, blob_ids, technical_details)
        {
            this.technical_details = technical_details;

            if ( message != null )
            {
                this.message = message.trim();
            }
            else
            {
                this.message = '';
            }

            if ( blob_ids )
            {
                this.blob_ids = blob_ids;
                this.downloadBlobIds(blob_ids);
            }

            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        downloadBlobIds(blob_ids)
        {
            this.$rc.getBlobMetaDataMultiple(
                blob_ids,
                (data) => {
                    this.blobs_meta_data = data.meta_data;
                },
                () => {
                    this.$rc.alert(
                        'Error Downloading Images',
                        'There was an error downloading image information. Please close and try again.'
                    );
                }
            );
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }

            // The dialog is showing...
            if ( this.is_valid )
            {
                this.dialog = false;
                next(false);
                return;
            }

            this.$rc.snackbar('You must either correct the errors or discard your changes.',1500);
            this.dialog = true;
            next(false);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>